module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-06-4c18cbd779c14432f43b2330549b938e.jpg";